export * from 'preact';
export { createPortal } from 'preact/compat';
export { ah as createContext, aa as flushSync } from './internal-common.js';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fullcalendar/core/preact.js
// module id = 384
// module chunks = 0